import React from 'react';
import {
  Card, CardBody, Col,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { getSubCategoryName, getImgByTitle, getImgCryptoByTitle } from '../../../utils/functions';

const addDefaultSrc = (ev) => {
  ev.target.src = `${process.env.PUBLIC_URL}/img/logo/default.png`;
};

const renderImg = (data) => {
  let img = 'default';
  const {
    category, title, subcategory,
  } = data;
  if (title) {
    let folderPath = subcategory === 'crypto_currency' ? '/crypto/' : '/logo/';
    let imgName = subcategory === 'crypto_currency' ? getImgCryptoByTitle(title) : getImgByTitle(title);
    if (['estate', 'bank', 'art', 'other_investment', 'art', 'item', 'intellectual', 'shop', 'company', 'contract'].includes(category)) {
      imgName = category;
      folderPath = '/';
    }
    img = `${folderPath + imgName}`;
  }
  return (
    <img onError={addDefaultSrc} style={{ marginBottom: 10, borderRadius: 0 }} className="topbar__avatar-img" src={`${process.env.PUBLIC_URL}/img/${img}.png`} alt="logo_img" />
  );
};

const renderTitle = (data) => {
  let { title } = data;
  if (!title) {
    if (data.url) {
      title = data.url;
    }
  }
  return title;
};

const AssetCard = ({
  data, openAsset,
}) => (
  <Col className="mb-10" xs={6} sm={4} md={4} lg={3} xl={2}>
    <Card style={{ paddingBottom: 10 }}>
      <CardBody className={`canClick assetCard ${data.category}`} onClick={() => openAsset(data)}>
        <div className="card__title mb-0">
          {renderImg(data)}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ flex: 1, overflow: 'hidden' }}>
              <h5 className="ellipsis bold-text">{renderTitle(data)}</h5>
              <h5 className="subhead">{getSubCategoryName(data)}</h5>
            </div>
          </div>
          {/* <div className="mt-20">
            {data.notes && <img className="note_img" src={`${process.env.PUBLIC_URL}/img/notes.png`} alt="notes_img" />}
            {data.documents && data.documents.length > 0 && <img className="note_img" src={`${process.env.PUBLIC_URL}/img/documents.png`} alt="notes_img" />}
          </div> */}
        </div>
      </CardBody>
    </Card>
  </Col>
);

AssetCard.propTypes = {
  data: PropTypes.shape({}),
  openAsset: PropTypes.func,
};

AssetCard.defaultProps = {
  data: {
    notes: '',
    contacts: [],
    decisions: [],
    title: '',
    value: '',
  },
  openAsset: () => {},
};

export default AssetCard;
